export default __webpack_public_path__ + "static/media/PaybackPeriod.2e4fea2f.svg";